// Vuex
import {mapActions} from 'vuex';
import * as PATIENT from '@/store/constants/patient';

// Components
import PersonalInformationForm from '../Form/PersonalInformationForm';
import OtherInformationForm from '../Form/OtherInformationForm';
import ContactForm from '../Form/ContactForm';
import InsuranceForm from '../Form/InsuranceForm';
import Notification from '@/views/Common/Notification';

// Mixins
import NotificationMixin from '@/mixins/notification';
import PayloadMerger from '@/mixins/payload-merger';

export default {
  inject: ['$validator'],
  name: "PatientAdd",
  data() {
    return {
      tabs: [
        {id: 'other-info-tab'},
        {id: 'insurance-tab'},
        {id: 'contact-tab'},
        {id: 'personal-info-tab'}
      ],
      inQueueForAppointments: false
    }
  },
  mixins: [NotificationMixin, PayloadMerger],
  components: {
    PersonalInformationForm,
    OtherInformationForm,
    ContactForm,
    InsuranceForm,
    Notification
  },

  methods: {
    ...mapActions({
      addPatient: PATIENT.ACTION_ADD
    }),

    resetData() {
      for (let tab of this.tabs) {
        Object.assign(this.$refs[tab.id].$data, this.$refs[tab.id].$options.data());
      }

      this.$nextTick(() => {
        this.errors.clear();
        this.$validator.reset();
      })
    },

    createAppointment(patient) {

    },

    save() {
      const personalInfo = this.$refs['personal-info-tab'].$data['personal_info'];
      const additionalPayloadRefs = ['other-info-tab', 'insurance-tab', 'contact-tab'];

      let payload = {...personalInfo};

      for (let refs of additionalPayloadRefs) {
        payload = this.mergePayload(payload, this.$refs[refs].$data)
      }

      this.addPatient(payload).then(res => {
        this.showSuccessNotification('Patient record successfully added.');

        if (this.inQueueForAppointments) this.createAppointment(res.data);

        this.resetData();
      }).catch(err => {
        let message = JSON.parse(err.response.data.message);
        message = Object.values(message).join("<br>");
        this.showErrorNotification(message);
      })
    },

    handleSave() {
      console.log('resetNotification');
      this.resetNotification();
      this.$validator.validateAll().then((res) => {
        if (res) this.save();
        else this.showErrorNotification('Please make sure you fill up all the required fields in all the tabs.');
      }).catch((err) => {
        this.showErrorNotification(err.response.message);
      });
    }
  },

  created() {
    this.inQueueForAppointments = this.$route.params['queue'] || false;
  }
}



// WEBPACK FOOTER //
// ./src/views/Patient/js/patient-add.js